export default {
  title: 'Milestones',
  columns: {
    milestone: 'Milestone',
    reachedOn: 'Reached on',
    recordedBy: 'Recorded by',
  },
  notReached: '—',
  emptyState: 'No milestones apply to this claim.',
  edit: 'Edit',
  date: 'Date',
  clear: 'Clear',
  cancel: 'Cancel',
  save: 'Save',
} as const;
